'use client';

import { useSystemEvents } from '@/lib/hooks/use-system-events/index';
import { NotificationManager } from '../Common/NotificationManager';

type ClientLayoutProps = {
  children: React.ReactNode;
  data: {
    commitSha: string;
    serverStartTime: number;
  };
};

export function ClientLayout({ children, data }: ClientLayoutProps) {
  useSystemEvents({
    commitSha: data.commitSha,
    serverStartTime: data.serverStartTime,
  });
  return (
    <>
      <NotificationManager />
      {children}
    </>
  );
}
